import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "../views/MainPage.vue";
import StudentInfo from "../views/StudentInfo.vue";
import StudentStudy from "../views/StudentStudy.vue";
import ClassAnalyse from "../views/ClassAnalyse.vue";
import ClassAnalyseF from "../views/ClassAnalyseF.vue";
import CourseManage from "@/views/CourseManage.vue";
import CourseAnalyse from "@/views/CourseAnalyse.vue";
import TeachersAll from "@/views/TeachersAll.vue";
import TeacherInfo from "@/views/TeacherInfo.vue";
import TeacherClass from "@/views/TeacherClass.vue";
import TeacherResourse from "@/views/TeacherResourse.vue";
Vue.use(VueRouter);
 
const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式
  routes: [
    { path: '/', name: 'MainPage', component: MainPage },
    { path: '/StudentInfo', name: 'StudentInfo', component: StudentInfo },
    { path: '/StudentStudy', name: 'StudentStudy', component: StudentStudy },
    { path: '/ClassAnalyse', name: 'ClassAnalyse', component: ClassAnalyse },
    { path: '/ClassAnalyseF', name: 'ClassAnalyseF', component: ClassAnalyseF },
    {path: '/CourseManage', name: 'CourseManage', component: CourseManage},
    {path: '/CourseAnalyse', name: 'CourseAnalyse', component: CourseAnalyse},
    { path: '/TeachersAll', name: 'TeacherProfile', component:TeachersAll},
    { path: '/TeacherInfo', name: 'TeacherInfo',component:TeacherInfo},
    { path: '/TeacherClass', name: 'TeacherClass',component:TeacherClass},
    { path: '/TeacherResourse',name: 'ResourseRelease',component:TeacherResourse}
  ]
});
 
export default router;